// extracted by mini-css-extract-plugin
export default {"payment":"Payment_payment__4z+0K","payment__row":"Payment_payment__row__fXLX+"};